// Generated by ReScript, PLEASE EDIT WITH CARE

import * as React from "react";
import * as JsxRuntime from "react/jsx-runtime";
import * as Button$PrezzeeRibbon from "../../personal/Button/Button.bs.js";
import * as BsCssJs$PrezzeeRibbon from "../../../bindings/BsCss/BsCssJs.bs.js";
import * as Theme__Color$PrezzeeRibbon from "../../../theme/Theme__Color.bs.js";
import * as Theme__Responsive$PrezzeeRibbon from "../../../theme/Theme__Responsive.bs.js";

var authButton = BsCssJs$PrezzeeRibbon.style([
      BsCssJs$PrezzeeRibbon.display("flex"),
      BsCssJs$PrezzeeRibbon.flexWrap("wrap"),
      BsCssJs$PrezzeeRibbon.flexBasis(BsCssJs$PrezzeeRibbon.pct(100)),
      BsCssJs$PrezzeeRibbon.media(Theme__Responsive$PrezzeeRibbon.desktop, [BsCssJs$PrezzeeRibbon.selector("button", [
                  BsCssJs$PrezzeeRibbon.marginLeft(BsCssJs$PrezzeeRibbon.px(10)),
                  BsCssJs$PrezzeeRibbon.paddingLeft(BsCssJs$PrezzeeRibbon.px(18)),
                  BsCssJs$PrezzeeRibbon.paddingRight(BsCssJs$PrezzeeRibbon.px(18)),
                  BsCssJs$PrezzeeRibbon.minWidth(BsCssJs$PrezzeeRibbon.px(125)),
                  BsCssJs$PrezzeeRibbon.whiteSpace("nowrap")
                ])]),
      BsCssJs$PrezzeeRibbon.media(Theme__Responsive$PrezzeeRibbon.belowLargeScreen, [
            BsCssJs$PrezzeeRibbon.nthChild({
                  NAME: "add",
                  VAL: [
                    1,
                    2
                  ]
                }, [BsCssJs$PrezzeeRibbon.marginTop(BsCssJs$PrezzeeRibbon.px(12))]),
            BsCssJs$PrezzeeRibbon.selector("button", [
                  BsCssJs$PrezzeeRibbon.flexBasis(BsCssJs$PrezzeeRibbon.pct(100)),
                  BsCssJs$PrezzeeRibbon.whiteSpace("nowrap")
                ])
          ])
    ]);

var Styles = {
  authButton: authButton
};

var buttonColour_0 = Theme__Color$PrezzeeRibbon.Common.prezzeeRed;

var buttonColour_1 = Theme__Color$PrezzeeRibbon.Business.white;

var buttonColour_2 = Theme__Color$PrezzeeRibbon.Common.darkRed;

var buttonColour = {
  _0: buttonColour_0,
  _1: buttonColour_1,
  _2: buttonColour_2,
  [Symbol.for("name")]: "Custom"
};

function Auth__Business__SignedOut(props) {
  return JsxRuntime.jsxs(React.Fragment, {
              children: [
                JsxRuntime.jsx(Button$PrezzeeRibbon.make, {
                      children: props.signInButton,
                      fill: /* None */2,
                      colour: buttonColour,
                      className: authButton
                    }),
                JsxRuntime.jsx(Button$PrezzeeRibbon.make, {
                      children: props.signUpButton,
                      colour: /* BusinessPurple */3,
                      variant: /* Small */1,
                      className: authButton
                    })
              ]
            });
}

var make = Auth__Business__SignedOut;

export {
  Styles ,
  buttonColour ,
  make ,
}
/* authButton Not a pure module */
